export const discoveryMenu = [
  {
    name: "My Projects",
    text:
      "Checkout some of my web projects i have created. As a little demonstration of my skills.",
    img: "progm.jpg",
    url: "/projects",
    urlText: "Explore now",
    animDelay: 0.5,
  },
  {
    name: "Contact Me",
    text:
      "Do not hesitate to contact if you want to hire or offer me some work, even have something to ask!",
    img: "handshead.jpg",
    url: "contact",
    urlText: "Contact",
    animDelay: 0.8,
  },
  {
    name: "More about me",
    text:
      "Get to know a bit about me. More related to my web development carrer and myself.",
    img: "colorful-boy.jpg",
    url: "/about",
    urlText: "Go to About Page",
    animDelay: 1.1,
  },
];

export const experience = [
  {
    num: "2+",
    txt: "Years Coding",
    dly: 0.5,
  },
  {
    num: "50+",
    txt: "Completed Pojects",
    dly: 0.7,
  },
  {
    num: "2+",
    txt: "Work Experience",
    dly: 0.9,
  },
  {
    num: "85%",
    txt: "Customer Service",
    dly: 1.1,
  },
];
